import { CollapsibleContentBlockData } from "@/storyblok/schemas";
import { renderRichText } from "@storyblok/js";
import ReadMore from "../read-more/ReadMore";
import { makeEditable } from "@/storyblok/visual-editor";
import { resolveImageUrl, resolveSectionClasses } from "@/storyblok/resolvers";

export default function CollapsibleContent({
  data,
}: {
  data: CollapsibleContentBlockData;
}) {
  const contentHtml = renderRichText(data.content);
  return (
    <section
      className="section--content-row"
      style={{ "--color-background": data.background_color?.color }}
      {...makeEditable(data)}
      id={data.anchor}
    >
      <div className={resolveSectionClasses(data, "container")}>
        <div className="col content-container">
          <h2>{data.title}</h2>
          <div
            dangerouslySetInnerHTML={{ __html: renderRichText(data.intro) }}
          ></div>

          {contentHtml && (
            <ReadMore>
              <div dangerouslySetInnerHTML={{ __html: contentHtml }}></div>
            </ReadMore>
          )}
        </div>
        <div className="col images-container">
          <div className="sub-image-container">
            <img
              src={resolveImageUrl(data.image, { width: 720 })}
              alt={data.image.alt}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
